/* import __COLOCATED_TEMPLATE__ from './couple-block.hbs'; */
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Super from './client-base';
import classic from 'ember-classic-decorator';
import styles from './couple-block.module.scss';

@classic
@classNames(styles.component)
export default class RequestInformationCoupleBlock extends Super {
  @service currentPractice;
  @service session;
}
